// extracted by mini-css-extract-plugin
module.exports = {"search-form":"SearchInput_search-form__2GVmg","input":"SearchInput_input__13gvN","btn":"SearchInput_btn__1WUix","btn-icon":"SearchInput_btn-icon__2DnVe"};